const LoadingButton = ({
  onClick,
  loading ,
  text = "Save",
  className = "",
  style = {},
  type = "button",
  disabled = false,
}) => {
  return (
    <button
      type={""}
      onClick={onClick}
      className={`btn btn-dark d-flex justify-content-center align-items-center ${className}`}
      style={{
        background: "#000000",
        color: "white",
        width: "140px",
        outline: "none",
        border: "none",
        ...style,
      }}
      disabled={loading || disabled}
    >
    {text}
      {loading ? (
        <span
          className="spinner-border spinner-border-sm ms-2"
          role="status"
          aria-hidden="true"
        ></span>
      ) :null}
    </button>
  );
};

export default LoadingButton;
